<div class="person"
     *ngIf="entity">

  <div class="person__main">
    <span class="sticker--entity-type">
      <i class="fal fa-{{entity?.entityType?.icon}} txt-12 mr-0037"
         *ngIf="entity?.entityType?.icon"></i>{{entity.entityType?.nameSingular}}
    </span>

    <div class="person__header">
      <app-entity-avatar [assessmentLevel]="entity.currentAssessmentLevel"
                         [spotlightIcon]="entity.spotlightIcon"
                         [isUser]="entity.linkedUserId"
                         [entityId]="entity.id"
                         [entityTypeId]="entity.entityTypeId"
                         [campaignId]="entity.campaignContextId"
                         size="lg">
      </app-entity-avatar>
      <h2 class="h2 person__detail">
        <app-entity-name class="w-100" [entity]="entity"></app-entity-name>
        <app-highlighted-topline [targetId]="entity.id"
                                 [targetType]="'Entity'"
                                 [campaignId]="entity.campaignContextId"
                                 [parentEntityId]="entity.id"
                                 [topline]="entity.appliedToplines?.item0"
                                 class="d-block w-auto">
        </app-highlighted-topline>
        <app-entity-contact-buttons *ngIf="withContactButtons"
                                    (click)="$event?.stopImmediatePropagation()"
                                    class="wlCore__contact"
                                    [trigger]
                                    [entityId]="entityId"
                                    [campaignId]="campaignId"></app-entity-contact-buttons>
      </h2>
    </div>
    <ng-content></ng-content>

  </div>

</div>
